<template>
  <div class="payMentDetails">
    <el-dialog :title="$t('data.initiate_refund')" :visible.sync="dialogTableVisible" width="680px" class="diglog-card" @close="close()">
      <div class="header-line" />
      <div class="section-title" style="margin-top: -8px" />
      <el-form ref="form" :model="form" label-width="150px" label-position="left">
        <el-form-item
          :label="$t('system.refund_method')"
          prop="refund_category"
          :rules="[
            { required: true, message: 'Refund method is required'}
          ]"
        >
          <el-radio-group v-model="form.refund_category" @change="statusChange">
            <el-radio v-if="isAllRefund" label="2">{{ $t('data.full_refund') }}</el-radio>
            <el-radio v-if="original_refund_status === 4" label="1">{{ $t('data.partial_refund') }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="refund_amount" required>
          <template slot="label">
            <span>{{ $t('data.refund_amount') }}</span>
          </template>
          <el-input-number
            v-model="form.refund_amount"
            class="mt-12"
            size="mini"
            :disabled="disabled"
            :placeholder="$t('data.refund_amount')"
            autocomplete="off"
            :max="allAmount"
            :min="0"
            clearable
            :controls="false"
            type="text"
            :precision="($store.getters.isIdMerchant || $store.getters.isVnMerchant) ? 0 : 2"
          />
          {{ $t('customerService.remaining_refundable_order_amount') }}
          <el-tooltip placement="top">
            <div slot="content" style="width: 300px;">
              <span>{{ $t('tips.remaining_refundable_amount_tip') }}</span>
            </div>
            <span> <svg-icon icon-class="icon-font-question" class="icon-question" style="font-size: 12px;" /></span>
          </el-tooltip>
          {{ ': ' + allAmount }}
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogTableVisible=false">{{ $t('components.cancel') }}</el-button>
        <el-button type="primary" @click="onClickSubmitBtn">{{ $t('components.confirm') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { paymentRefund } from '@/api/customer-service/customer-service'
export default {
  name: 'Payin_Refund_Modal',
  components: {
  },
  props: {
    detailId: {
      type: [Number, String],
      default: '0'
    }
  },
  data() {
    return {
      id: null,
      form: {
        refund_amount: null
      },
      dialogTableVisible: false,
      disabled: true,
      allAmount: null,
      fullRefund: false,
      original_refund_status: null,
      isAllRefund: true
    }
  },
  methods: {
    onClickSubmitBtn() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const { refund_amount, ...otherSearch } = this.form
          if (refund_amount === 0) {
            this.$message.warning('Refund amount cannot be zero')
            return
          }
          if (this.isAllRefund && this.form.refund_category === '1') {
            if (refund_amount === this.allAmount) {
              this.$message.warning('As the refund amount is equal to the order amount, please select Full Refund as the refund method.')
              return
            }
          }
          const params = { transaction_id: this.detailId, refund_amount: this.$commonFn.mathMultiply(refund_amount, 100), ...otherSearch }
          paymentRefund(params).then(res => {
            if (res.code === 10000) {
              this.$message.success('Success')
              this.$emit('updatelist')
              this.dialogTableVisible = false
            }
          })
        }
      })
    },
    // 改变弹框状态
    changModalStatus(value, row) {
      this.dialogTableVisible = value
      this.allAmount = this.$commonFn.mathDivide(row.available_refund_amount, 100)
      this.original_refund_status = row.original_refund_status
      this.isAllRefund = row.real_transaction_amount === row.available_refund_amount
      if (!this.isAllRefund) {
        this.form.refund_category = '1'
        this.disabled = false
        this.form.refund_amount = 0
      }
    },
    onClickCancal() {
      this.changModalStatus(false)
    },
    statusChange() {
      if (this.form.refund_category === '2') {
        this.disabled = true
        this.form.refund_amount = this.allAmount
      } else {
        this.disabled = false
        this.form.refund_amount = 0
      }
    },
    close() {
      this.form = {
        refund_category: null,
        refund_amount: null
      }
      this.disabled = true
      this.$nextTick(function() {
        this.$refs['form'].clearValidate()
      })
    }
  }
}
</script>
<style>
.diglog-card .el-form-item__label{
  line-height: 36px;
}
.diglog-card .el-form-item {
  margin-bottom: 10px;
}
</style>
<style scoped lang="scss">
.total{
  display: inline-flex;
  justify-content: space-between;
  margin-top: 18px;
  min-width: 300px;

  .line{
    display: inline-block;
    content:'';
    height: 52px;
    width: 1px;
    background: #D3D7DF;
  }
  &-title{
    font-size: 14px;
    line-height: 17px;
    color: #606266;
  }
  &-num{
    margin-top: 12px;
    font-size: 22px;
    font-family: Source Han Sans SC;
    font-weight: 600;
    font-family: 'Inter-SemiBold';
    line-height: 1.2;
    color: #3855F1;
  }
}
.item{
  margin-top: 16px;
  .item-left{
    display: inline-block;
    width: 250px;
  }
}

.payMentDetails{
  .payin-status{
    text-align: center;
    position: absolute;
    top: 20px;
    left: 160px;
  }
}
.mt-12{
  margin-top: 12px;
}

</style>
